import { render, staticRenderFns } from "./Annotations.vue?vue&type=template&id=1dbbacca"
import script from "./Annotations.vue?vue&type=script&lang=ts"
export * from "./Annotations.vue?vue&type=script&lang=ts"
import style0 from "./Annotations.vue?vue&type=style&index=0&id=1dbbacca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports